webpackJsonp([237385593936810],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// utils
	var PageIntro = function PageIntro(_ref) {
	  var children = _ref.children,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-intro' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'page-intro__title' },
	      title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'page-intro__text' },
	      children
	    )
	  );
	};
	
	// style
	// vendor
	
	
	PageIntro.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.string.isRequired
	};
	
	exports.default = PageIntro;
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ArticleList = __webpack_require__(28);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	var _PageIntro = __webpack_require__(29);
	
	var _PageIntro2 = _interopRequireDefault(_PageIntro);
	
	var _PageTitle = __webpack_require__(16);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// utils
	// vendor
	var DégustationsPage = function DégustationsPage(_ref) {
	  var data = _ref.data;
	
	  var articles = function articles() {
	    if (data.articles) {
	      return data.articles.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return {
	          thumbnail: {
	            sizes: node.hero.sizes,
	            alt: node.hero.title
	          },
	          date: node.publicationDate,
	          title: node.title,
	          excerpt: node.description.description,
	          id: node.id,
	          path: node.fields.path
	        };
	      });
	    }
	
	    return [];
	  };
	
	  var style = {};
	
	  style.title = {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    width: '1px'
	  };
	
	  var _data$site$siteMetada = data.site.siteMetadata,
	      siteUrl = _data$site$siteMetada.siteUrl,
	      siteTitle = _data$site$siteMetada.title;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'D\xE9gustations | ' + siteTitle
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'Pr\xE9sentation des bi\xE8res Coureurs des Boires et d\'autres moments de d\xE9gustations notables en lien avec les travaux du duo'
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', value: 'summary' }),
	      _react2.default.createElement('meta', {
	        property: 'og:title',
	        content: 'D\xE9gustations | Les coureurs des boires'
	      }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: siteUrl + '/degustations' }),
	      _react2.default.createElement('meta', {
	        property: 'og:description',
	        content: 'Pr\xE9sentation des bi\xE8res Coureurs des Boires et d\'autres moments de d\xE9gustations notables en lien avec les travaux du duo'
	      }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'Les coureurs des boires' }),
	      _react2.default.createElement('link', { rel: 'canonical', href: siteUrl + '/degustations' })
	    ),
	    _react2.default.createElement(
	      'h1',
	      { style: style.title },
	      'D\xE9gustations'
	    ),
	    _react2.default.createElement(_PageTitle2.default, { title: 'D\xE9gustations' }),
	    _react2.default.createElement(
	      _PageIntro2.default,
	      { title: 'D\xE9gustations' },
	      'Pr\xE9sentation de bi\xE8res issues de nos recherches et et produites au Qu\xE9bec, ainsi que d\'autres articles o\xF9 on analyse l\'acte de d\xE9gustation'
	    ),
	    _react2.default.createElement(_ArticleList2.default, { articles: articles() })
	  );
	};
	
	// components
	
	
	// vendor components
	var query = exports.query = '** extracted graphql fragment **';
	
	DégustationsPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  }).isRequired
	};
	
	exports.default = DégustationsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-degustations-jsx-46887f2197c17738beb3.js